import React from 'react';

import { observer } from 'mobx-react';

import Button from 'bz-core-controls/controls/general/button';
import { EDirection } from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import BzPopoverStore, { BzPopoverStoreContext } from 'bz-stores/mobx/popover-store';

import OptionsPopover from './controls/options-popover';
import OptionsControlReorder from './controls/reorder-button';

export interface IProps {
  onSublist: () => void;
}

const NestedPageOptions: React.FC<IProps> = observer(({ onSublist }) => {
  const [popoverStore] = React.useState(() => new BzPopoverStore());

  const open = React.useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    popoverStore.open(e.currentTarget);
  }, []);

  return (
    <BzPopoverStoreContext.Provider value={popoverStore}>
      <>
        <div className="flex-none">
          <div className="flex-row flex-nowrap gap-x-2.5">
            <Button small={true} onClick={onSublist}>
              <span>Add Sublist</span>
            </Button>
            <OptionsControlReorder direction={EDirection.up} />
            <OptionsControlReorder direction={EDirection.down} />
            <Button small={true} onClick={open}>
              <i className="fa fa-gear" />
            </Button>
          </div>
        </div>
        <OptionsPopover />
      </>
    </BzPopoverStoreContext.Provider>
  );
});

NestedPageOptions.displayName = 'NestedPageOptions';

export default NestedPageOptions;
